import React from "react";
import classNames from "classnames";
import { Link } from "react-router-dom";

const FooterNav = ({ className, ...props }) => {
  const classes = classNames("footer-nav", className);

  return (
    <nav {...props} className={classes}>
      <ul className="list-reset">
        <li>
          <Link to="/contact">Contact</Link>
        </li>
        <li>
          <Link to="/about">About us</Link>
        </li>
        <li>
          <Link to="/privacy">Policy</Link>
        </li>
        <li>
          <a
            href="https://policies.google.com/terms#toc-what-you-expect"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default FooterNav;
